import React from 'react';

import tabular from './TabularView/TabularView';
import empty from './EmptyView/EmptyView';
import ItemView from './ItemView/ItemView';

const ViewItemView = (props) => {
    return <ItemView {...props} readonly={true}></ItemView>;
};

const viewMap  = {
    tabular,
    empty,
    // edit: (props) => <ItemView {...props} />,
    edit: ItemView,
    view: ViewItemView,
    // view: (props) => <ItemView {...props} readonly={true} />,
};

export const viewProps = {
    tabular: { scrollable: false },
}

export default viewMap;